module.exports = {
      id: "album-usage",
      viewBox: "0 0 25.602 21.762",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#album",
      toString: function () {
        return this.url;
      }
    }